module.exports = __webpack_public_path__ + "assets/img/ic-wel-lock.62bd2323.png";